import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectBathroomType = createSelector(selectJsonQuery, jsonQuery => getTermValue('wc_type')(jsonQuery));
